/** クーポン利用時間 入力可能単位(分) */
export const couponMinuteStepUnit = 30

/** クーポン利用時間 最大入力可能利用時間(分) デフォルト初期値 */
export const couponMaxUsageMinuteDefault = 24 * 60
